import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { PageHeader } from '../components/shared/PageHeader';
import { StatusBadge } from '../components/shared/StatusBadge';
import { UrgencyBadge } from '../components/shared/UrgencyBadge';
import { useAppContext } from '../lib/store';
import { FileText, CheckCircle2, Clock, Plus, Building2, ListTodo, ArrowRight } from 'lucide-react';
export function DashboardPage() {
  const navigate = useNavigate();
  const {
    workOrders,
    customers,
    auth
  } = useAppContext();
  // Stats calculations
  const openWorkOrders = workOrders.filter(wo => wo.status !== 'Zaključeno' && wo.status !== 'Stornirano');
  const completedWorkOrders = workOrders.filter(wo => wo.status === 'Zaključeno');
  const today = new Date().toISOString().split('T')[0];
  const todayWorkOrders = workOrders.filter(wo => wo.execution_date === today);
  const recentWorkOrders = [...workOrders].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()).slice(0, 5);
  return <div className="space-y-6" data-id="element-308">
      <PageHeader title={`Pozdravljeni, ${auth.user?.full_name.split(' ')[0]}`} description="Pregled stanja delovnih nalogov in hitre akcije." data-id="element-309">
        <Button onClick={() => navigate('/nalogi/nov')} data-id="element-310">
          <Plus className="w-4 h-4 mr-2" data-id="element-311" />
          Nov nalog
        </Button>
      </PageHeader>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-312">
        {/* Recent Work Orders */}
        <Card className="lg:col-span-2" data-id="element-313">
          <CardHeader className="flex flex-row items-center justify-between" data-id="element-314">
            <CardTitle data-id="element-315">Zadnji ustvarjeni nalogi</CardTitle>
            <Button variant="ghost" size="sm" onClick={() => navigate('/nalogi')} data-id="element-316">
              Vsi nalogi <ArrowRight className="w-4 h-4 ml-2" data-id="element-317" />
            </Button>
          </CardHeader>
          <CardContent data-id="element-318">
            <div className="space-y-4" data-id="element-319">
              {recentWorkOrders.map(wo => {
              const customer = customers.find(c => c.id === wo.customer_id);
              return <div key={wo.id} className="flex flex-col md:flex-row md:items-center justify-between p-4 border rounded-lg hover:bg-slate-50 cursor-pointer transition-colors gap-2" onClick={() => navigate(`/nalogi/${wo.id}`)} data-id="element-320">
                    <div className="flex flex-col gap-1" data-id="element-321">
                      <div className="flex items-center gap-2" data-id="element-322">
                        <span className="font-semibold text-primary" data-id="element-323">
                          {wo.work_order_number}
                        </span>
                        <span className="text-sm text-slate-500" data-id="element-324">
                          • {customer?.name}
                        </span>
                      </div>
                      <span className="text-sm text-slate-600 truncate max-w-[300px] md:max-w-[400px]" data-id="element-325">
                        {wo.work_description || 'Brez opisa'}
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-326">
                      <UrgencyBadge urgency={wo.urgency} data-id="element-327" />
                      <StatusBadge status={wo.status} data-id="element-328" />
                    </div>
                  </div>;
            })}
              {recentWorkOrders.length === 0 && <div className="text-center py-8 text-slate-500" data-id="element-329">
                  Ni nedavnih delovnih nalogov.
                </div>}
            </div>
          </CardContent>
        </Card>

        {/* Quick Actions */}
        <Card data-id="element-330">
          <CardHeader data-id="element-331">
            <CardTitle data-id="element-332">Hitre akcije</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3" data-id="element-333">
            <Button className="w-full justify-start h-12" onClick={() => navigate('/nalogi/nov')} data-id="element-334">
              <Plus className="w-5 h-5 mr-3 text-white/70" data-id="element-335" />
              Nov delovni nalog
            </Button>
            <Button variant="outline" className="w-full justify-start h-12" onClick={() => navigate('/stranke/nova')} data-id="element-336">
              <Building2 className="w-5 h-5 mr-3 text-slate-400" data-id="element-337" />
              Nova stranka
            </Button>
            <Button variant="outline" className="w-full justify-start h-12" onClick={() => navigate('/nalogi')} data-id="element-338">
              <FileText className="w-5 h-5 mr-3 text-slate-400" data-id="element-339" />
              Seznam nalogov
            </Button>
            <Button variant="outline" className="w-full justify-start h-12" onClick={() => navigate('/stranke')} data-id="element-340">
              <Building2 className="w-5 h-5 mr-3 text-slate-400" data-id="element-341" />
              Seznam strank
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>;
}